import { type Scene } from "three"
import type { Engine } from "../../../core/engine/Engine.type"
import createTerrainMesh1V3GridEffect from "./createTerrainMesh1V3GridEffect"
import createTerrainMesh1V3QuadTreeEffect from "./createTerrainMesh1V3QuadTreeEffect"
import createTerrainMesh1V3RidgeV3EdgesEffect from "./Ridge/createTerrainMesh1V3RidgeV3EdgesEffect"

export default function createTerrainMesh1V3Effect(
  engine: Engine,
  scene: Scene,
): void {
  createTerrainMesh1V3GridEffect(engine, scene)
  // console.log('createTerrainMesh1V3Effect.init')
  // const getTileGraphNodesList = createSharedTileGraphNodeCollectionMemo(engine)
  // const getGridSize = useGridWidthHeight(engine)
  // createTerrainMesh1V3QuadTreeEffectDebug(engine, scene)
  createTerrainMesh1V3QuadTreeEffect(engine, scene)

  // const material = createRidgeMaterial(engine, scene)
  // material.wireframe = true

  // const geometryList: Array<BufferGeometry> = []
  // // const edgeGeometryByIndexReactiveMap: Map<number, BufferGeometry> = new Map()
  // const [trackGeometryList, dirtyGeometryList] = createTriggerSignal()
  // const [getBatchedMesh, setBatchedMesh] = createSignal<BatchedMesh | undefined>()

  // createEffect(() => {
  //   trackGeometryList()
  //   const maxInstanceCount = geometryList.length
  //   if (maxInstanceCount) {
  //     // console.time('createBatchedMeshWithGeometryList')
  //     const batchedMesh = createBatchedMeshWithGeometryList(
  //       maxInstanceCount, geometryList, material
  //     )

  //     // console.timeEnd('createBatchedMeshWithGeometryList')

  //     // console.time('addGeometry')
  //     for (let i = 0; i < geometryList.length; i++) {
  //       const geometry = geometryList[i]
  //       const geometryID = batchedMesh.addGeometry(geometry)
  //       const instanceID = batchedMesh.addInstance(geometryID)
  //       geometry.userData.i = instanceID
  //       geometry.userData.g = geometryID
  //     }
  //     // console.timeEnd('addGeometry')
  //     // console.time('scene.add(batchedMesh)')
  //     scene.add(batchedMesh)
  //     // console.timeEnd('scene.add(batchedMesh)')

  //     // batchedMesh.position.y += 0.2
  //     // batchedMesh.position.y += 0.5
  //     // batchedMesh.position.y += 1

  //     onMount(() => {
  //       setBatchedMesh(batchedMesh)
  //       enableShadows(batchedMesh)
  //     })
  //     // if (DEV) {
  //     //   const geometryList2 = geometryList.map((geometry) => {
  //     //     const geometry2 = geometry.clone()
  //     //     // geometry2.scale.set(1.01, 1.01, 1.01)
  //     //     return geometry2
  //     //   })
  //     //   const material2 = new MeshLambertMaterial({
  //     //     // color: 0xFF00FF,
  //     //     side: DoubleSide,
  //     //     vertexColors: true,
  //     //   })
  //     //   const batchedMesh2 = createBatchedMeshWithGeometryList(
  //     //     maxInstanceCount, geometryList2, material2
  //     //   )

  //     //   for (let i = 0; i < geometryList2.length; i++) {
  //     //     const geometry = geometryList2[i]
  //     //     const geometryID = batchedMesh2.addGeometry(geometry)
  //     //     const instanceID = batchedMesh2.addInstance(geometryID)
  //     //     geometry.userData.i = instanceID
  //     //     geometry.userData.g = geometryID
  //     //   }

  //     //   setTimeout(() => {
  //     //     scene.add(batchedMesh2)
  //     //     batchedMesh2.position.copy(batchedMesh.position)
  //     //     batchedMesh2.position.y = batchedMesh.position.y
  //     //     // batchedMesh2.visible = true
  //     //     onCleanupRemoveAndDispose(batchedMesh2)
  //     //   }, 1)
  //     // }
  //     onCleanupRemoveAndDispose(batchedMesh)
  //   }
  // })

  // createEffect(() => {
  //   console.log('createTerrainMesh1V3Effect.effect.gridSize', getGridSize())
  // })

  // createEffect(() => {
  //   console.log('createTerrainMesh1V3Effect.effect.getTileGraphNodesList', getTileGraphNodesList().length)
  // })

  // createEffect(() => {
  //   console.log('createTerrainMesh1V3Effect.effect')
  //   const gridSize = getGridSize()
  //   const tpNodeList = getTileGraphNodesList()
  //   const mesh = createTerrainMesh1V3Mesh(engine, gridSize, tpNodeList)
  //   rotatePlaneToLayFlat(mesh)
  //   // mesh.position.y += 1.01 // debug raise above water
  //   mesh.visible = false
  //   scene.add(mesh)

  //   adjustForEngineBug(engine, mesh)

  //   onCleanupRemoveAndDispose(mesh)
  // })

  // createTerrainMesh1V3RidgeV2EdgesEffect(engine, scene,
  //   geometryList, dirtyGeometryList,
  //   getBatchedMesh, ridgeGeometryByEdgeMap)

  createTerrainMesh1V3RidgeV3EdgesEffect(engine, scene)
    
  // createTerrainMesh1V3RidgeV1CornersEffect(engine, scene,
  //   geometryList, dirtyGeometryList,
  //   getBatchedMesh)

  // createTerrainMesh1V3RidgeDebugPointsEffect(engine, scene)
}

// function adjustForEngineBug(engine: Engine, obj: Object3D): void {
//   // no idea why this is needed
//   if (isEngineScreenShot(engine)) {
//     const offset = VERTICES_PER_TILE * 0.8
//     obj.position.x -= offset
//     obj.position.z -= offset
//   }
//   if (isEngineArmyPainter(engine)) {
//     const offset = VERTICES_PER_TILE * 1.3
//     obj.position.x -= offset
//     obj.position.z -= offset
//   }
// }